import _defineProperty from "@babel/runtime/helpers/defineProperty";
import validateColourScheme from './validate-colour-scheme';
let instance;
class ChartOptions {
  constructor() {
    _defineProperty(this, "colourSchemes", void 0);
    _defineProperty(this, "animationDuration", 2500);
    if (instance) {
      throw new Error('You can only create one instance!');
    }
    instance = this;
    this.colourSchemes = {
      default: null,
      datasets: []
    };
  }
  setDefaultColourScheme(colourScheme) {
    const defaultScheme = validateColourScheme(colourScheme);
    if (!defaultScheme) {
      return;
    }
    this.colourSchemes.default = defaultScheme;
  }
  setDatasetsColourSchemes(colourSchemes) {
    if (!Array.isArray(colourSchemes)) {
      return;
    }
    const validatedColourSchemes = colourSchemes.map(colourScheme => validateColourScheme(colourScheme)).filter(Boolean);
    this.colourSchemes.datasets = validatedColourSchemes;
  }
  setAnimationDuration(duration) {
    if (typeof duration !== 'number' || duration < 0) {
      return;
    }
    this.animationDuration = duration;
  }
  getDefaultColourScheme() {
    return this.colourSchemes.default;
  }
  getAllaDatasetsColourScheme() {
    return this.colourSchemes.datasets;
  }
  getDatasetColourScheme(index) {
    return this.colourSchemes.datasets[index] || null;
  }
  getAnimationDuration() {
    return this.animationDuration;
  }
  getInstance() {
    return this;
  }
}
const chartOptionsHandler = new ChartOptions();
export default chartOptionsHandler;
//# sourceMappingURL=chart-options-handler.js.map